import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import * as yup from 'yup';

const useReLoginPopupFormValidationSchema = () => {
	const { t } = useTranslation();

	return useMemo(
		() =>
			yup.object({
				password: yup.string().required(t('Required')),
			}),
		[t],
	);
};

export default useReLoginPopupFormValidationSchema;
